/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/**
 * A function that does nothing. Can be used in place of a required function,
 * or for stubbing out behavior in tests.
 *
 * In production code, it's usually better to make functions optional, or default a context that
 * contains functions to null instead of using stubbed out state.
 */
function noop() { }
/**
 * A function that returns its argument unchanged. Can be used to stub out a callback that accepts
 * a transform function, for example, where the "transform" is to do nothing.
 */
function identity(x) {
    return x;
}
/**
 * Returns a promise that resolves after `ms` milliseconds.
 */
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
/**
 * Safely calls `methodName` on the given `obj`. Makes sure the method
 * exists as a function and that it accepts 0 arguments.
 *
 * @returns `true` if the method was called, `false` otherwise.
 */
function noArgCallSafely(obj, methodName) {
    if (obj &&
        typeof obj === 'object' &&
        methodName in obj &&
        typeof obj[methodName] === 'function' &&
        obj[methodName].length === 0) {
        obj[methodName]();
        return true;
    }
    return false;
}
/**
 * Combine multiple functions into one which will call all of them in order. Useful for combining
 * multiple cleanup functions into one, for example. Falsy values are ignored.
 */
function callEach(...fns) {
    return () => {
        for (const fn of fns) {
            if (fn)
                fn();
        }
    };
}

export { callEach, identity, noArgCallSafely, noop, sleep };
//# sourceMappingURL=fn.js.map
